// Latest virtual-background (RVM) diagnostic snapshot, published by
// backgroundProcessor and read by voiceTelemetry so the RVM internal state
// (which is otherwise console-only) lands in ClickHouse voice_diag_samples.
// Decoupled module-level value — same pattern as backgroundEngineFlag — so the
// telemetry collector doesn't need a handle to the live processor instance.
export interface BackgroundDiag {
  /** A real person matte has been composited at least once (person visible). */
  ready: boolean
  /** Runtime auto-fallback to the stock engine was requested (RVM gave up). */
  fallback: boolean
  /** composite() is showing BACKGROUND-ONLY right now (no valid matte → person not visible). */
  privacyHolding: boolean
  /** Matte (inference) frames per second, smoothed. */
  matteFps: number
  /** Last RVM inference duration in ms. */
  inferMs: number
  /** Consecutive inference errors. */
  inferErrors: number
  /** ONNX execution provider actually in use ('wasm' | 'webgpu' | ''). */
  ep: string
  /** Composite (paint) frames per second, smoothed — the published-frame rate. */
  compositeFps: number
}

let latest: BackgroundDiag | null = null

export function setBackgroundDiag(d: BackgroundDiag | null): void { latest = d }
export function getBackgroundDiag(): BackgroundDiag | null { return latest }
